import { Tooltip, useDisclosure } from '@chakra-ui/react'
import React, { useContext } from 'react'
import { ButtonHeaderModule } from 'styled/Buttons.styled'
import { IconGeneric } from 'styled/Icons.styled'
import { MdContentCopy, MdOutlineAssignmentReturn } from 'react-icons/md'
import { BiMoney } from 'react-icons/bi'
import { FaHistory } from 'react-icons/fa'

import { AuthContext } from 'context/AuthContext'
import { useSelector } from 'react-redux'
import { localPermissions } from 'Permissions/permissions'
import { hasCommonElements } from 'utils/type-check-utils'
import ModalReturnHistory from 'components/modal/ModalReturnHistory'

export const ButtonCaducar = ({ handleCopy, handleDescaducar, handleIngresar, data, isLoading }) => {
  const { authUser } = useContext(AuthContext)
  const { isOpen: isOpenReturnHistory, onOpen: onOpenReturnHistory, onClose: onCloseReturnHistory } = useDisclosure()

  const { permissionList } = useSelector(state => state.permissions)
  const { changeStatus: changeStatusEntryForm, copy: copyEntryForm,  createPass: createPassEntryForm } =
    localPermissions.Entryform

  return (
    <>
      <ModalReturnHistory
        isOpen={isOpenReturnHistory}
        onClose={onCloseReturnHistory}
        onOpen={onOpenReturnHistory}
        title={'Historial de Devoluciones'}
        size={'3xl'}
        entryFormId={data?.id}
      />
      {data?.reason_for_return && (
        <Tooltip placement='top' hasArrow label='Historial de Devoluciones'>
          <span>
            <ButtonHeaderModule
              onClick={onOpenReturnHistory}
              bgColor='#FF9800'
              className='me-1'
              isLoading={isLoading}
            >
              <IconGeneric
                width='16px'
                className='text-white'
                as={FaHistory}
              />
            </ButtonHeaderModule>
          </span>
        </Tooltip>
      )}
      {(hasCommonElements(permissionList, copyEntryForm) ||
        authUser.admin === 1) && (
        <Tooltip placement='top' hasArrow label='Copiar'>
          <span>
            <ButtonHeaderModule
              className='me-1'
              onClick={handleCopy}
              bgColor='#03C39A'
            >
              <IconGeneric
                width='16px'
                className='text-white'
                as={MdContentCopy}
              />
            </ButtonHeaderModule>
          </span>
        </Tooltip>
      )}

      {authUser.is_qualified_user !== 1 &&
        (hasCommonElements(permissionList, changeStatusEntryForm) ||
          authUser.admin === 1) && (
          <Tooltip placement='top' hasArrow label='Descaducar'>
            <span>
              <ButtonHeaderModule bgColor='#F9A621' onClick={handleDescaducar}>
                <IconGeneric
                  className='text-white'
                  width='16px'
                  as={MdOutlineAssignmentReturn}
                />
              </ButtonHeaderModule>
            </span>
          </Tooltip>
        )}

      {(hasCommonElements(permissionList, createPassEntryForm) ||
        authUser.admin === 1) &&
        data?.io_pass_different_state_enabled === true && (
          <Tooltip placement='top' hasArrow label='Ingresar'>
            <span>
              <ButtonHeaderModule
                onClick={handleIngresar}
                bgColor='#BABABA'
                disabled={isLoading}
              >
                <IconGeneric width='16px' className='text-white' as={BiMoney} />
              </ButtonHeaderModule>
            </span>
          </Tooltip>
        )}
    </>
  )
}
